module.exports = __webpack_public_path__ + "img/no_data.1f4a550e.svg";